module.exports = __webpack_public_path__ + "static/media/seta.d8222381.svg";